import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, CanLoad, Route } from '@angular/router';
import { UserService } from 'services';
import { Observable } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { UserClaimTypeExtended } from 'models';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanLoad {
    constructor(private userService: UserService, private toastrService: ToastrService) { }

    /**
     * Checking if current user can load route provided
     *
     * @param route
     *
     * @return Observable<boolean>
     */
    canLoad(route: Route): Observable<boolean> {

        const allowedClaims: UserClaimTypeExtended[] = route.data.allowedClaims;
        if (allowedClaims === undefined || !Array.isArray(allowedClaims))
            throw new Error(
                `'allowedClaims' data property for '${route.path}' route is not defined`
            );

        return this.userService.userTokenClaims$.pipe(
            take(1),
            map((roles: UserClaimTypeExtended[]) => {
                if (!roles.length && allowedClaims.indexOf('Unauthenticated') !== -1) {
                    return true;
                } else if (roles.filter(role => -1 !== allowedClaims.indexOf(role)).length > 0) {
                    return true;
                } else {
                    this.toastrService.error(
                        "You don't have sufficient permissions for this action"
                    );
                    return false;
                }
            })
            // catchError((error: any) => empty())
        );
    }

    /**
     * Checking if current user can activate the route
     *
     * @param route<ActivatedRouteSnapshot>
     *
     * @return Observable<boolean>
     */
    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        const allowedClaims: UserClaimTypeExtended[] = route.data.allowedClaims;
        if (allowedClaims === undefined || !Array.isArray(allowedClaims))
            throw new Error(
                `'allowedClaims' data property for '${route.url}' route is not defined`
            );

        return this.userService.userTokenClaims$.pipe(
            take(1),
            map((roles: UserClaimTypeExtended[]) => {
                if (!roles.length && allowedClaims.indexOf('Unauthenticated') !== -1) {
                    return true;
                } else if (roles.filter(role => -1 !== allowedClaims.indexOf(role)).length > 0) {
                    return true;
                } else {
                    this.toastrService.error(
                        "You don't have sufficient permissions for this action"
                    );
                    return false;
                }
            })
            // catchError((error: any) => empty())
        );
    }
}
